import { StrictMode, type ReactElement } from 'react';
import { createRoot } from 'react-dom/client';

const DEFAULT_CONTAINER_ID = 'react-root';

// All Django-served calculator pages mount React into the same template placeholder.
// Keeping this bootstrap in one place prevents the entrypoints from drifting.
export function bootstrapReactApp(appName: string, app: ReactElement, containerId: string = DEFAULT_CONTAINER_ID): void {
  const container = document.getElementById(containerId);

  if (!container) {
    if (import.meta.env.DEV === true) {
      console.warn(`[${appName}] No element with id="${containerId}" found. React app not mounted.`);
    }
    return;
  }

  createRoot(container).render(<StrictMode>{app}</StrictMode>);
}
